import {Agencies} from './views';
import {Activities} from './views';

export default [
    {
        path: "/admin/agencies",
        name: "Agencies",
        component: Agencies,
        meta: {
            authGuard: (user) => user.isAdmin
        }
    },
    {
        path: "/admin/activities",
        name: "Activities",
        component: Activities,
        meta: {
            authGuard: (user) => user.isAdmin
        }
    },

];
